// Fills a section with answers from a previous report of the same evaluated WITHOUT overwriting anything typed:
// only empty fields, empty lists and empty table cells take the previous value.
export const isEmptyValue = (value) => {
  if (value === undefined || value === null || value === '') return true
  if (Array.isArray(value)) return value.every(item => (item && typeof item === 'object' && !item.path ? isEmptyObject(item) : false))
  if (typeof value === 'object' && !value.path) return isEmptyObject(value)
  return false
}

const isEmptyObject = (obj) => Object.values(obj).every(isEmptyValue)

export const fillEmptyAnswers = (fields, current = {}, previous = {}) => {
  const answers = { ...current }
  let filled = 0
  fields.forEach(field => {
    const source = previous[field.key]
    if (isEmptyValue(source)) return
    const target = answers[field.key]

    if (field.type === 'TABLE') {
      const table = { ...(target || {}) }
      Object.keys(source).forEach(row => {
        Object.keys(source[row] || {}).forEach(column => {
          const cell = source[row][column]
          if (!isEmptyValue(cell) && isEmptyValue(table[row] && table[row][column])) {
            table[row] = { ...(table[row] || {}), [column]: cell }
            filled += 1
          }
        })
      })
      answers[field.key] = table
      return
    }

    if (isEmptyValue(target)) {
      answers[field.key] = source
      filled += 1
    }
  })
  return { answers, filled }
}
